import React, { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { SfcShellAppBarIcon, SdfCard, SdfSelectSimple } from '@waypoint/react-components';
import { SHELL_NAV_ICON } from '../../constants';
import { SessionContext } from '../../session';
import languageTranslation from '../../common/languageTranslation';

export default function LocaleSwitcher() {
  const [showLocaleMenu, setShowLocaleMenu] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState({});
  const languageOptions = [{ label: 'EN', value: 'en' }, { label: 'FR', value: 'fr-CA' }];
  const { i18n } = useTranslation();
  const session = useContext(SessionContext);
  const menuRef = useRef(null);
  const localeIconRef = useRef(null);

  useEffect(() => {
    document.body.addEventListener('click', onClickOutside);
    return () => document.removeEventListener('click', onClickOutside);
  }, []);

  useEffect(() => {
    setSelectedLanguage(languageOptions.find(option => option.value === i18n.language));
  }, [i18n.language]);

  const onClickOutside = e => {
    const element = e.target;
    if (localeIconRef.current && localeIconRef.current.contains(element)) {
      return;
    }
    if (menuRef.current && !menuRef.current.contains(element)) {
      return setShowLocaleMenu(false);
    }
  };

  async function switchLocale(locale) {
    await axios.put(`${import.meta.env.VITE_API_PATH}/user-settings`, { locale }, { withCredentials: true });
    session.updateLocale?.(locale);
  }

  return (
    <>
      <SfcShellAppBarIcon
        slot="icons"
        icon="status-public"
        ref={localeIconRef}
        className={`${SHELL_NAV_ICON} md:mr-4`}
        label={languageTranslation('common.language')}
        href="javascript:void(0)"
        onClick={() => {
          setShowLocaleMenu(!showLocaleMenu);
        }}
      />
      <div
        ref={menuRef}
        className={showLocaleMenu ? '' : 'hidden'}
        style={{ position: 'fixed', top: '4rem', right: '8rem' }}
      >
        <SdfCard>
          <SdfSelectSimple
            label={languageTranslation('common.selectlanguage')}
            items={languageOptions}
            value={selectedLanguage}
            onSdfChange={e => {
              switchLocale(e.detail.value);
              setShowLocaleMenu(false);
            }}
          />
        </SdfCard>
      </div>
    </>
  );
}
